import React from "react";
import GoalContentAddEditPageV2 from "./GoalContentAddEditPageV2";

/** Route element for /goal-content/new — the create variant of the topic form page. */
export default function GoalContentCreatePageV2() {
  return <GoalContentAddEditPageV2 mode="create" />;
}
